/* NINJA TYO — behaviour.

   Everything here is ADDITIVE. The site is fully usable with this file
   blocked: the nav is a <details> element, and .nt-reveal only hides once
   .nt-js confirms scripting is alive.

   ⚠ THIS FILE RUNS FROM THE HEADER SECTION, WHICH IS ABOVE THE CONTENT.
   The first version queried .nt-reveal immediately, found ZERO elements
   (the page below had not been parsed yet), hit an early return, and so
   never registered the observer OR the safety-net timer. Every card and
   every About block stayed at opacity 0 permanently — the whole catalogue
   was invisible.

   Two defences now, and BOTH matter:
     1. the <script> tag carries `defer`, so it runs after parsing
     2. ready() below waits for DOMContentLoaded anyway, so moving the tag
        or dropping the defer cannot resurrect the bug
   Never query .nt-reveal at top level again. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    /* ---------- mobile menu ----------
       Below 720px the desktop bar is hidden, so without this there is
       literally no menu on a phone — which is most of the traffic. */
    var burger = document.querySelector('.nt-burger');
    var nav = document.getElementById('nt-nav');

    if (burger && nav) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        burger.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
        nav.classList.toggle('is-open', !open);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (burger.getAttribute('aria-expanded') === 'true') {
          burger.click();
          burger.focus();
        }
      });
    }

    /* Close any open dropdown when a click lands outside it.
       <details> handles Escape natively but not click-away. */
    document.addEventListener('click', function (e) {
      var open = document.querySelectorAll('.nt-drop[open]');
      for (var i = 0; i < open.length; i++) {
        if (!open[i].contains(e.target)) open[i].removeAttribute('open');
      }
    });

    /* ---------- scroll reveal ----------
       Purely additive. If there is nothing to reveal, or no observer
       support, everything is shown immediately. A 1.5s timer force-reveals
       anything the observer misses, so content can NEVER be stranded
       invisible. */
    var els = document.querySelectorAll('.nt-reveal');

    function showAll() {
      for (var i = 0; i < els.length; i++) els[i].classList.add('in');
    }

    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--d', (i % 6) * 40 + 'ms');
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );

    for (var j = 0; j < els.length; j++) io.observe(els[j]);

    /* Safety net. Registered unconditionally, because a throttled or
       backgrounded tab can stop the observer from ever firing. */
    setTimeout(showAll, 1500);
  });
})();
